import ValidService from "@/service/ValidService";
let model = {};

// dữ liệu form
model.dataForm = {
  name: null, // required - Tên danh mục tin
  order: null, // optional - Thứ tự
};

// validation form
model.validForm = {
  name: [ValidService.required, ValidService.checkMaxLength(100)], // required - Tên danh mục tin
  order: [ValidService.checkNumberInteger, ValidService.checkNumberFloatNotNegative], // optional - Thứ tự
};

model.tableRules = {
  data: [],
  lengthMenu: [10, 20, 50, 100],
  allowPaging: true,
  allowSorting: true,
  allowSelect: true,
  showFormSearch: false,
  showUrl: true,
  total: 0,
  page: 1,
  limit: 10,
  offset: 0,
  sort: "order,-created_at",
  defaultSort: ["order", "ascending"],
  filters: "",
  recordSelected: [],
  dataSearch: {
    value: {
      name: null,
      is_important: null,
      disabled: null
    },
    valid: {
    },
    operator: {
      name: '$vn_text=',
      is_important: '',
      disabled: ''
    }
  }
};

export default model;
